var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCategorySports = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.213 9.79H16m0 0 2.172-1.322a1.334 1.334 0 0 1 1.959.717l3.072 9.216 4.322 5.762a2.401 2.401 0 0 1-1.921 3.842h-5.242a5.328 5.328 0 0 1-3.907-1.702L5.062 14.041a4.001 4.001 0 0 1 .33-5.759L9.957 4.37a1.546 1.546 0 0 1 2.552 1.174V9.79H16ZM3.995 23.338h2.668m4.001 4.668h-6.67m23.407-4.002h-6.702a3.977 3.977 0 0 1-2.926-1.272L4.869 8.834m12.465 8.5 5.209-.902M16 14l5.42-.938",
  stroke: "#717680",
  strokeWidth: 2.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIcCategorySports;